import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import InvoiceTemplate from './InvoiceTemplate';
import { Box, CircularProgress } from '@mui/material';

export default function InvoiceView() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type') === 'purchase' ? 'purchase' : 'sale';
  const autoPrint = searchParams.get('print') === '1';
  const [invoice, setInvoice] = useState(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      try {
        const res = await fetch(type === 'purchase' ? `/api/purchase-invoices/${id}` : `/api/sale-invoices/${id}`);
        if (!res.ok) { setInvoice(null); setLoading(false); return; }
        const body = await res.json();
        const data = body?.data || {};
        const inv = data.invoice || null;
        setInvoice(inv ? { ...inv, consignee: data.consignee || null, extra: data.extra || null } : null);
        setItems(data.items || []);
        if (inv?.invoice_no) {
          const billedTo = inv.party_name || inv.customer_name || inv.vendor_name || '';
          document.title = billedTo
            ? `${inv.invoice_no} - ${billedTo}`.replace(/[\\/:*?"<>|]/g, '_')
            : inv.invoice_no;
        }
      } catch (e) {
        setInvoice(null);
      }
      setLoading(false);
    }
    fetchData();
  }, [id, type]);

  if (loading) return <Box p={4} textAlign="center"><CircularProgress /></Box>;
  if (!invoice) return <Box p={4} textAlign="center">Invoice not found.</Box>;

  return <InvoiceTemplate invoice={invoice} items={items} autoPrint={autoPrint} />;
}